import { render, staticRenderFns } from "./TreatmentHistory.vue?vue&type=template&id=e9210996&scoped=true&"
import script from "./TreatmentHistory.vue?vue&type=script&lang=ts&"
export * from "./TreatmentHistory.vue?vue&type=script&lang=ts&"
import style0 from "./TreatmentHistory.vue?vue&type=style&index=0&id=e9210996&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9210996",
  null
  
)

export default component.exports